import React from 'react'
import { useTranslation } from 'react-i18next'
import { Line } from 'rc-progress'
import styles from './psqProgressBar.module.scss'

const PsqProgressBar = ({ step, totalSteps }: { step: number; totalSteps: number }) => {
  const { t: tCommon } = useTranslation('strCommon')

  const stepToPercentTransform = (step: number, totalSteps: number): number => {
    return (100 * step) / totalSteps
  }

  return (
    <div className={styles.psqProgressBar}>
      <span className={styles.title}>
        <b>{step}</b> <span>{tCommon('of')}</span> <span>{totalSteps}</span>{' '}
      </span>
      <Line
        data-testid='progress-bar'
        className={styles.line}
        percent={stepToPercentTransform(step, totalSteps)}
        strokeColor='#003a70'
        trailColor='#ebedef'
        strokeWidth={1}
      />
    </div>
  )
}

export default PsqProgressBar
